import React, { useState } from 'react';
import '../styles/WhatsAppModal.css';
import { FaTimes, FaWhatsapp } from 'react-icons/fa';

const WhatsAppModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const sendToWhatsApp = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = formData;

    const text = `*Hello FU-TEK Automation, I would like a free consultation.*\n*Name:* ${name}\n*Email:* ${email}\n*Phone:* ${phone}\n*Subject:* ${subject}\n*Message:* ${message}`;
    const whatsappUrl = `https://wa.me/917046062908?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, '_blank');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="unique-whatsapp-modal-overlay">
      <div className="unique-whatsapp-modal-box">
        <div className="unique-whatsapp-modal-header">
          <div className="unique-whatsapp-modal-header-left">
<h3><FaWhatsapp className="whatsapp-green-icon" /> Chat on WhatsApp</h3>
          </div>
          <button className="unique-whatsapp-modal-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <form className="unique-whatsapp-modal-form" onSubmit={sendToWhatsApp}>
          <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
          <input type="tel" name="phone" placeholder="Your Phone" value={formData.phone} onChange={handleChange} required />
          <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} required />
          <textarea name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} required />
          <button type="submit" className="unique-whatsapp-modal-submit-btn">Send via WhatsApp</button>
        </form>
      </div>
    </div>
  );
};

export default WhatsAppModal;
